

enum ReviewsContentFilterInput {
	ALL = 'ALL', ONLY_TEXT = 'ONLY_TEXT'
}

export default ReviewsContentFilterInput;
